export default "__VITE_ASSET__CCbPNqFi__"